 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTSUBTITLEPAGE from '@/components/Text/sub-title-page'
 import TEXTOTHERBOOKSBY from '@/components/Text/otherbooksby'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTPREFACE from '@/components/Text/Preface'
 import TEXTCHAPTER_01 from '@/components/Text/Chapter_01'
 import TEXTCHAPTER_02 from '@/components/Text/Chapter_02'
 import TEXTCHAPTER_03 from '@/components/Text/Chapter_03'
 import TEXTCHAPTER_04 from '@/components/Text/Chapter_04'
 import TEXTCHAPTER_05 from '@/components/Text/Chapter_05'
 import TEXTCHAPTER_06 from '@/components/Text/Chapter_06'
 import TEXTCHAPTER_07 from '@/components/Text/Chapter_07'
 import TEXTCHAPTER_08 from '@/components/Text/Chapter_08'
 import LOVE_2 from '@/components/love_2'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/acknowledgments'
 import TEXTABOUT from '@/components/Text/about'
 import TEXTCTA from '@/components/Text/cta'
 import TEXTOTHERBOOKS from '@/components/Text/otherbooks'
 import TEXTAD1 from '@/components/Text/ad1'
 import TEXTAD2 from '@/components/Text/ad2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/titlepage",
 			"name" : "Text/titlepage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/copyright",
 			"name" : "Text/copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/sub-title-page",
 			"name" : "Text/sub-title-page",
 			"component" : TEXTSUBTITLEPAGE
 		},
 		{
 			"path" : "/Text/otherbooksby",
 			"name" : "Text/otherbooksby",
 			"component" : TEXTOTHERBOOKSBY
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/dedication",
 			"name" : "Text/dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/Preface",
 			"name" : "Text/Preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/Chapter_01",
 			"name" : "Text/Chapter_01",
 			"component" : TEXTCHAPTER_01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js